import FiltersService from "@/services/FiltersService";
import { defineStore } from "pinia";
import { useAuthStore } from "./auth.store";

// Definicja store Pinia do zarządzania filtrami VMS
export const useVmsFilterStore = defineStore({
  id: "vmsFilter",
  state: () => ({
    filters: {},        // przechowuje aktualnie wybrane filtry
    locations: [],      // lista wszystkich lokalizacji (np. stacji, znaków)
    authStore: useAuthStore(), // odwołanie do autoryzacji (do obsługi błędów)
  }),
  getters: {
    // Getter zwracający cały obiekt filtrów
    items: (state) => state.filters,

    // Getter zwracający wybrane lokalizacje jako obiekty (po id)
    selectedLocation: (state) => {
      if (state.filters.locations) {
        // Zwróć tylko te lokalizacje, których id są w filtrach
        return state.locations.filter((location) => {
          return state.filters.locations.includes(location.id);
        });
      }
      return [];
    },
  },
  actions: {
    /**
     * Pobiera listę lokalizacji z API, tylko jeśli nie została już pobrana
     */
    getLocations() {
      if (this.locations.length === 0) {
        FiltersService.getLocations()
          .then((data) => {
            this.locations = data;
          })
          .catch((e) => {
            console.error(e);
          });
      }
    },

    /**
     * Zaznacza (dodaje do filtrów) pierwszą lokalizację na liście
     */
    checkAllLocations() {
      this.filters.locations = [this.locations[0].id];
    },

    /**
     * Dodaje (lub ustawia) filtr. Specjalna obsługa dla lokalizacji - tylko jedna zaznaczona naraz.
     * @param {string} name - nazwa filtra (np. 'LocationList', 'status', 'type')
     * @param {any} value - wartość filtra
     */
    addItem(name, value) {
      switch (name) {
        case "LocationList": {
          if (this.filters.locations) {
            if (!this.filters.locations.includes(value)) {
              // Jeżeli nie było tej lokalizacji - ustaw ją
              this.filters.locations = [value];
            } else {
              // Jeżeli już była wybrana - usuń ją (odznaczenie)
              this.filters.locations = [];
            }
          } else {
            this.filters.locations = [value];
          }
          // Jeśli nic nie zostało - usuń property z obiektu filtrów
          if (this.filters.locations.length == 0) {
            delete this.filters.locations;
          }
          break;
        }
        default: {
          // Dla innych filtrów - ustaw po prostu wartość
          this.filters[name] = value;
        }
      }
    },

    /**
     * Usuwa dany filtr z obiektu filtrów
     * @param {string} name - nazwa filtra
     */
    removeItem(name) {
      switch (name) {
        default: {
          delete this.filters[name];
        }
      }
    },

    /**
     * Ustawia globalny komunikat błędu (np. do wyświetlenia w UI)
     */
    setErrors(error) {
      this.authStore.errorMessage = error;
    },
  },
});

// Hot Module Reloading dla Pinia Store podczas developmentu (nie wpływa na produkcję)
// if (typeof import.meta !== 'undefined' && import.meta.hot) {
//   import.meta.hot.accept(acceptHMRUpdate(useVmsFilterStore, import.meta.hot));
// }
